/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_Mod_NeutralInputs */

const en_coach_risk_mod_neutral = /** @type {(inputs: Coach_Risk_Mod_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your readiness is balanced, but your training ramp rate is above the safe zone. Hold steady or slightly reduce this week to let your body catch up before pushing further.`)
};

const de_coach_risk_mod_neutral = /** @type {(inputs: Coach_Risk_Mod_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Bereitschaft ist ausgeglichen, aber die Trainingsrampe liegt über der sicheren Zone. Halte das Niveau oder fahr leicht zurück, damit dein Körper aufholen kann.`)
};

/**
* | output |
* | --- |
* | "Your readiness is balanced, but your training ramp rate is above the safe zone. Hold steady or slightly reduce this week to let your body catch up before pus..." |
*
* @param {Coach_Risk_Mod_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_mod_neutral = /** @type {((inputs?: Coach_Risk_Mod_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_Mod_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_mod_neutral(inputs)
	return de_coach_risk_mod_neutral(inputs)
});